import { getPendingTransactions } from '../../api/transactions'
import { useAuthQuery } from '@/hooks/use-auth-query'

const useGetPendingTransactions = () => {
  return useAuthQuery({
    queryKey: ['pending_transactions'],
    queryFn: getPendingTransactions,
    refetchOnWindowFocus: true,
    staleTime: 1 * 60 * 1000, // 1 minute
    cacheTime: 3 * 60 * 1000, // 3 minutes
  })
}

export default useGetPendingTransactions
